export const URLS = {
  BASE_API_URL: "https://refund.nalovas.com/",
  // BASE_API_URL: "http://localhost:5001",
  USER_LOGIN: "user",
  ADMIN_LOGIN: "admin",
};
